import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import Modal from 'react-modal';
import { toast } from 'react-toastify';
import {
  fetchAreas,
  fetchCustomerGroups,
  fetchCustomers,
  fetchDistricts,
  fetchPaymentMethods,
  fetchLogisticLines,
  searchProducts,
  fetchPaymentStatus,
  addOrders,
} from '../services/ordersService';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from './ConfirmationModal';
import BasicTimePicker from '../../../components/BasicTimePicker';
import { showSuccessToast } from '../../../utils/toastHelper';
import { AsyncPaginate } from 'react-select-async-paginate';
import useDynamicInputWidth from '../hooks/useDynamicInputWidth';

const AddOrderModalUpdate = ({
  setAddModal,
  actionType,
  selectedOrdersEdit,
  onSuccess,
}) => {
  const { t } = useTranslation('Order');
  const category = 'FBZ';
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [tmrCheck, setTmrCheck] = useState(false);
  // State for each input field
  const [loader, setLoader] = useState(false);
  const [deliveryDate, setDeliveryDate] = useState('');
  const [customerGroup, setCustomerGroup] = useState({});

  const [referenceNumber, setReferenceNumber] = useState('');
  const [poNumber, setPoNumber] = useState('');
  // const [deliveryAddress, setDeliveryAddress] = useState('');
  // const [area, setArea] = useState('');
  // const [district, setDistrict] = useState('');
  const [contactPerson, setContactPerson] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  // const [paymentMethod, setPaymentMethod] = useState('');
  const [deliveryAddressManual, setManualDeliveryAddress] = useState('');
  const [areaManual, setManualArea] = useState({ name: '', id: '' });
  const [districtManual, setManualDistrict] = useState({ name: '', id: '' });
  const [logisticLineManual, setManualLogisticLine] = useState({
    name: '',
    id: '',
  });
  const [paymentMethodManual, setPaymentMethodManual] = useState({
    name: '',
    id: '',
  });
  const [paymentStatus, setPaymentStatus] = useState({ name: '', id: '' });
  const [contactPersonManual, setManualContactPerson] = useState('');
  const [contactPhoneManual, setManualContactPhone] = useState('');
  const [earliestDeliveryTimeFromManual, setManualEarliestDeliveryTimeFrom] =
    useState('');
  const [earliestDeliveryTimeToManual, setManualEarliestDeliveryTimeTo] =
    useState('');
  const [latestDeliveryTimeFromManual, setManualLatestDeliveryTimeFrom] =
    useState('');
  const [latestDeliveryTimeToManual, setManualLatestDeliveryTimeTo] =
    useState('');

  const [paymentDate, setPaymentDate] = useState('');
  const [orderRemark, setOrderRemark] = useState('');
  const [additionalFee, setAdditionalFee] = useState('');
  const [earliestDeliveryTimeFrom, setEarliestDeliveryTimeFrom] = useState('');
  const [earliestDeliveryTimeTo, setEarliestDeliveryTimeTo] = useState('');
  const [latestDeliveryTimeFrom, setLatestDeliveryTimeFrom] = useState('');
  const [latestDeliveryTimeTo, setLatestDeliveryTimeTo] = useState('');
  const [groupNames, setGroupNames] = useState([]);
  const [customers, setCustomers] = useState([]);
  const [productInfo, setProductsInfo] = useState([]);
  const [enableInput, setEnableInput] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState({});
  const [products, setProducts] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedOrdersEdit) {
        if (selectedOrdersEdit?.customer_id) {
          setEnableInput(false);
        } else {
          await getArea();
          await getDistrict();
          await getPaymentMethod();
          setEnableInput(true);
        }
        getCustomers(selectedOrdersEdit?.customer_group?.id);
        setCustomerGroup(selectedOrdersEdit.customer_group || {});
        setManualLogisticLine({
          name: selectedOrdersEdit.logistic_line?.name || '',
          id: selectedOrdersEdit.logistic_line_id || '',
        });
        setPaymentMethodManual({
          name: selectedOrdersEdit.payment_method?.name || '',
          id: selectedOrdersEdit.payment_method_id || '',
        });

        if (selectedOrdersEdit.customer_id === null) {
          // Pre-fill manual fields

          setManualDeliveryAddress(selectedOrdersEdit.delivery_address || '');
          setManualArea({
            name: selectedOrdersEdit.area?.name || '',
            id: selectedOrdersEdit.area_id || '',
          });
          setManualDistrict({
            name: selectedOrdersEdit.district?.name || '',
            id: selectedOrdersEdit.district_id || '',
          });
          setManualContactPerson(selectedOrdersEdit.contact_name || '');
          setManualContactPhone(selectedOrdersEdit.contact_phone || '');
          setManualEarliestDeliveryTimeFrom(
            selectedOrdersEdit.earliest_delivery_time?.split('-')[0] || ''
          );
          setManualEarliestDeliveryTimeTo(
            selectedOrdersEdit.earliest_delivery_time?.split('-')[1] || ''
          );
          setManualLatestDeliveryTimeFrom(
            selectedOrdersEdit.latest_delivery_time?.split('-')[0] || ''
          );
          setManualLatestDeliveryTimeTo(
            selectedOrdersEdit.latest_delivery_time?.split('-')[1] || ''
          );
        } else if (selectedOrdersEdit.customer_id !== null) {
          setSelectedCustomer(selectedOrdersEdit?.customer);

          // Pre-fill non-manual fields
          // setDeliveryAddress(selectedOrdersEdit.delivery_address || '');
          // setArea(selectedOrdersEdit.area?.name || '');
          // setDistrict(selectedOrdersEdit.district?.name || '');
          setContactPerson(selectedOrdersEdit.contact_name || '');
          setContactPhone(selectedOrdersEdit.contact_phone || '');
          // setPaymentMethod(selectedOrdersEdit.payment_method?.name || '');
          setEarliestDeliveryTimeFrom(
            selectedOrdersEdit.earliest_delivery_time?.split('-')[0] || ''
          );
          setEarliestDeliveryTimeTo(
            selectedOrdersEdit.earliest_delivery_time?.split('-')[1] || ''
          );
          setLatestDeliveryTimeFrom(
            selectedOrdersEdit.latest_delivery_time?.split('-')[0] || ''
          );
          setLatestDeliveryTimeTo(
            selectedOrdersEdit.latest_delivery_time?.split('-')[1] || ''
          );
        }
      }
    };
    fetchData();
  }, [selectedOrdersEdit]);
  const dynamicSizeInputRefs = useRef([]);
  const specificationInputRefs = useRef([]);
  const productRemarkInputRefs = useRef([]);
  useDynamicInputWidth(dynamicSizeInputRefs, products);
  useDynamicInputWidth(
    specificationInputRefs,
    products,
    (item) => item.specification
  );
  useDynamicInputWidth(
    productRemarkInputRefs,
    products,
    (item) => item.productRemark
  );
  const [saveToCustomerData, setSaveToCustomerData] = useState('no');
  const handleRadioChange = (e) => {
    setSaveToCustomerData(e.target.value);
  };
  const handlePaymentStatusChange = (e) => {
    const selectedPaymentStatus = paymentOptions.find(
      (area) => area.name === e.target.value
    );
    setPaymentStatus({
      name: e.target.value,
      id: selectedPaymentStatus?.id || '',
    });
  };
  const handleAreaChange = (e) => {
    const selectedArea = areaOptions.find(
      (area) => area.name === e.target.value
    );
    setManualArea({ name: e.target.value, id: selectedArea?.id || '' });
  };

  const handleDistrictChange = (e) => {
    const selectedDistrict = districtOptions.find(
      (district) => district.name === e.target.value
    );
    setManualDistrict({ name: e.target.value, id: selectedDistrict?.id || '' });
  };

  const handleLogisticLineChange = (e) => {
    const selectedLogisticLine = logisticLineOptions.find(
      (line) => line.name === e.target.value
    );
    setManualLogisticLine({
      name: e.target.value,
      id: selectedLogisticLine?.id || '',
    });
  };

  const handlePaymentMethodChange = (e) => {
    const selectedPaymentMethod = paymentMethodsOptions.find(
      (method) => method.name === e.target.value
    );
    setPaymentMethodManual({
      name: e.target.value,
      id: selectedPaymentMethod?.id || '',
    });
  };
  const toggleEdit = (index) => {
    const updatedProducts = [...products];
    updatedProducts[index].isEditing = !updatedProducts[index].isEditing;
    setProducts(updatedProducts);
  };

  const addProduct = () => {
    setProducts([
      ...products,
      {
        productCode: '',
        productName: '',
        origin: '',
        specification: '',
        quantity: '',
        unitPrice: '',
        discount: '',
        productRemark: '',
        processLocation: '',
        productId: '',
        isEditing: true,
      },
    ]);
  };

  const removeProduct = (index) => {
    const updatedProducts = products.filter((_, i) => i !== index);
    setProducts(updatedProducts);
  };

  useEffect(() => {
    // getGroups();
    // getCustomerCodes();
    getPaymentStatus();
    getLogisticLine();
  }, []);
  const [paymentOptions, setPaymentOption] = useState([]);

  const getPaymentStatus = async () => {
    try {
      const response = await fetchPaymentStatus();
      setPaymentOption(response?.payment_statuses || []);
    } catch (error) {
      console.error('Error fetching areas:', error);
    }
  };

  // const getGroups = async () => {
  //   try {
  //     const response = await fetchCustomerGroups({ category });
  //     setGroupNames(response?.customer_groups || []); // Stores available areas
  //   } catch (error) {
  //     console.error('Error fetching areas:', error);
  //   }
  // };
  const handleDropdownChange = (field, value) => {
    const selectedCustomerElement = customers.find(
      (customer) => customer.id === value
    );
    if (selectedCustomerElement) {
      setSelectedCustomer(selectedCustomerElement);

      setContactPerson(selectedCustomerElement.contact_name || null);
      setContactPhone(selectedCustomerElement.contact_phone || null);

      // Check if delivery times exist before splitting
      if (selectedCustomerElement.earliest_delivery_time) {
        const [from, to] =
          selectedCustomerElement.earliest_delivery_time.split('-');
        setEarliestDeliveryTimeFrom(from || '');
        setEarliestDeliveryTimeTo(to || '');
      } else {
        setEarliestDeliveryTimeFrom('');
        setEarliestDeliveryTimeTo('');
      }

      if (selectedCustomerElement.latest_delivery_time) {
        const [from, to] =
          selectedCustomerElement.latest_delivery_time.split('-');
        setLatestDeliveryTimeFrom(from || '');
        setLatestDeliveryTimeTo(to || '');
      } else {
        setLatestDeliveryTimeFrom('');
        setLatestDeliveryTimeTo('');
      }
    }
  };
  const handleCustomerGroupChange = (e) => {
    console.log('e:', e);
    if (!e) {
      setCustomerGroup(null);
      resetCustomerFields();
      return;
    }
    const selectedGroupId = e.value;
    // const selectedGroupId = e.target.value;
    const selectedGroup = groupNames.find(
      (group) => group.id === selectedGroupId
    );
    setCustomerGroup(selectedGroup);
    resetCustomerFields();
    getCustomers(selectedGroup?.id);
  };
  const resetCustomerFields = () => {
    setSelectedCustomer({});
    // setDeliveryAddress('');
    // setArea('');
    // setDistrict('');
    setContactPerson('');
    setContactPhone('');
    // setPaymentMethod('');
    setEarliestDeliveryTimeFrom('');
    setEarliestDeliveryTimeTo('');
    setLatestDeliveryTimeFrom('');
    setLatestDeliveryTimeTo('');
  };

  const getCustomers = async (groupId) => {
    try {
      const query = { customerGroups: [groupId] };
      const response = await fetchCustomers(query); // Pass the groupId to fetchAreas
      setCustomers(response?.customers);

      // Handle the response (e.g., update state for areas)
    } catch (error) {
      console.error('Error fetching customer:', error);
    }
  };

  // const [enableInput, setEnableInput] = useState(false);
  const toggleInput = (value) => {
    setEnableInput(value);
    if (value === true) {
      getArea();
      getDistrict();
      getPaymentMethod();
    }
  };

  const [areaOptions, setAreas] = useState([]);
  const [districtOptions, setDistricts] = useState([]);
  const [logisticLineOptions, setLogistics] = useState([]);
  const [paymentMethodsOptions, setPaymentMethods] = useState([]);

  const getArea = async () => {
    try {
      const response = await fetchAreas();
      setAreas(response?.areas || []);
    } catch (error) {
      console.error('Error fetching areas:', error);
    }
  };

  const getDistrict = async () => {
    try {
      const response = await fetchDistricts();
      setDistricts(response?.districts || []);
    } catch (error) {
      console.error('Error fetching districts:', error);
    }
  };

  const getLogisticLine = async () => {
    try {
      const response = await fetchLogisticLines();
      const logisticLines = response?.logistic_lines || [];

      // Find the element with the specific ID
      const selectedLogistic = logisticLines.find(
        (item) => item.name === '天霖國際有限公司'
      );

      // Set states
      setLogistics(logisticLines);
      setManualLogisticLine(
        selectedLogistic
          ? { name: selectedLogistic.name, id: selectedLogistic.id }
          : { name: '', id: '' }
      );
    } catch (error) {
      console.error('Error fetching logistic lines:', error);
    }
  };

  const getPaymentMethod = async () => {
    try {
      const response = await fetchPaymentMethods();
      setPaymentMethods(response?.payment_methods || []);
    } catch (error) {
      console.error('Error fetching payment methods:', error);
    }
  };
  const handleProductChange = async (index, e) => {
    const { name, value, selectedOptions } = e.target;
    const selectedId = selectedOptions
      ? selectedOptions[0].getAttribute('data-id')
      : null;

    // Update the product state
    const updatedProducts = [...products];
    updatedProducts[index][name] = value;

    // Validate discount if unitPrice, quantity, or discount changes
    if (name === 'unitPrice' || name === 'quantity' || name === 'discount') {
      validateDiscount(updatedProducts, index);
    }

    setProducts(updatedProducts);

    // Make an API call using the selectedId
    if (selectedId) {
      try {
        const matchedProduct = productInfo.find(
          (product) => product.id === selectedId
        );

        // Update the product state with the fetched details
        updatedProducts[index] = {
          ...updatedProducts[index],
          productId: matchedProduct?.id,
          productName: matchedProduct?.name || '',
          // specification: matchedProduct?.specification || '',
          specification: matchedProduct.specification_value
            ? `${matchedProduct.specification_value} ${matchedProduct?.specification_unit?.name ?? ''} / ${matchedProduct.product_value} ${matchedProduct?.product_unit?.name ?? ''}`
            : matchedProduct.product_value
              ? `${matchedProduct.product_value} ${matchedProduct?.product_unit?.name ?? ''}`
              : '',
          origin: matchedProduct.origin?.name || '',
          processLocation: matchedProduct?.process_location?.name || '',
        };
        setProducts(updatedProducts);
      } catch (error) {
        console.error('Error fetching product details:', error);
      }
    }
  };

  // Helper function to validate discount
  const validateDiscount = (products, index) => {
    const discount = parseFloat(products[index].discount) || 0;
    const unitPrice = parseFloat(products[index].unitPrice) || 0;
    const quantity = parseFloat(products[index].quantity) || 0;

    const productValue = unitPrice * quantity;

    if (discount > productValue) {
      toast.error(`Discount cannot exceed product value (${productValue})`);
      products[index].discount = productValue; // Set to max allowed value
    }
  };

  // const fetchProductDetails = async (id) => {
  //   try {
  //     const page = 1;
  //     const per_page = 999999;
  //     const search = '';
  //     const query = { page, per_page, search, FBZ: 1 };
  //     const response = await searchProducts(query);
  //     setProductsInfo(response?.products || []);
  //   } catch (error) {
  //     console.error('Error fetching payment methods:', error);
  //   }
  // };
  const productsLoadOptions = async (inputValue, loadedOptions, { page }) => {
    const per_page = 50;
    const query = { page, per_page, search: inputValue, FBZ: 1 };

    const productsResponse = await searchProducts(query);
    // setProductsInfo(productsResponse?.products || []);
    setProductsInfo((prev) => [...prev, ...(productsResponse?.products || [])]);

    const newOptions = productsResponse.products?.map((product) => ({
      // value: product.id,
      // label: `${product.name} | (${product.code})`,
      // productObject: product,
      value: product.code || product.name,
      label: `${product.code} - ${product.name}`,
      id: product.id,
    }));
    return {
      options: newOptions,
      hasMore:
        productsResponse.pagination.current_page <
        productsResponse.pagination.last_page,
      additional: {
        page: page + 1,
      },
    };
  };

  const customerGroupLoadOptions =
    (labelType = 'code') =>
    async (inputValue, loadedOptions, { page }) => {
      const per_page = 50;
      const query = { page, per_page, search: inputValue, category };
      const customerGroupResponse = await fetchCustomerGroups(query);

      setGroupNames((prev) => [
        ...prev,
        ...(customerGroupResponse?.customer_groups || []),
      ]);

      const newOptions = customerGroupResponse.customer_groups?.map(
        (group) => ({
          value: group.id,
          label:
            labelType === 'code'
              ? `${group.code}`
              : labelType === 'group'
                ? `${group.group}`
                : `${group.code} - ${group.group}`,
        })
      );

      return {
        options: newOptions,
        hasMore:
          customerGroupResponse.pagination.current_page <
          customerGroupResponse.pagination.last_page,
        additional: {
          page: page + 1,
        },
      };
    };

  // const getCustomerCodes = async () => {
  //   try {
  //     const page = 1;
  //     const per_page = 100;
  //     const search = '';
  //     const query = { page, per_page, search };
  //     const response = await fetchProductDetails({ query });
  //   } catch (error) {
  //     console.error('Error fetching payment methods:', error);
  //   }
  // };

  const formatTimeRange = (from, to) => {
    if (!from) return null; // If 'from' is missing, return null
    return to ? `${from}-${to}` : from; // Include 'to' only if it's selected
  };
  const saveSubmit = async () => {
    // Validate time ranges
    if (enableInput) {
      if (
        !validateTimeRange(
          earliestDeliveryTimeFromManual,
          earliestDeliveryTimeToManual,
          'Earliest Delivery Time'
        ) ||
        !validateTimeRange(
          latestDeliveryTimeFromManual,
          latestDeliveryTimeToManual,
          'Latest Delivery Time'
        )
      ) {
        return;
      }
    } else {
      if (
        !validateTimeRange(
          earliestDeliveryTimeFrom,
          earliestDeliveryTimeTo,
          'Earliest Delivery Time'
        ) ||
        !validateTimeRange(
          latestDeliveryTimeFrom,
          latestDeliveryTimeTo,
          'Latest Delivery Time'
        )
      ) {
        return;
      }
    }
    if (!referenceNumber) {
      toast.error('Please enter reference number');
      return;
    } else if (!poNumber) {
      toast.error('Please enter PO number');
      return;
    } else if (!logisticLineManual.name) {
      toast.error('Please select logistic line');
      return;
    }
    if (enableInput) {
      if (!areaManual) {
        toast.error('Please select area');
        return;
      } else if (!districtManual) {
        toast.error('Please select district');
        return;
      }
    }

    // Get the current date and time

    if (!tmrCheck) {
      const now = new Date();
      const currentHour = now.getHours();
      const currentMinutes = now.getMinutes();

      // Check if the delivery date is tomorrow
      const deliveryDateObj = new Date(deliveryDate);
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      const isPast1730 =
        currentHour > 17 || (currentHour === 17 && currentMinutes > 30);
      // Check if delivery date is tomorrow and time is after 4 PM
      if (
        deliveryDateObj.toDateString() === tomorrow.toDateString() &&
        isPast1730
      ) {
        // Open the confirmation modal
        setConfirmationModal(true);
        return; // Stop further execution
      }
    }

    setLoader(true); // Start loading
    // Map over the products array to extract only the required fields
    const simplifiedProducts = products.map((product) => ({
      product_id: product?.productId, // Assuming productCode is the selected product ID
      quantity: product?.quantity,
      unit_price: product?.unitPrice,
      remarks: product?.productRemark,
      discount: product?.discount,
    }));
    var data = '';
    if (!enableInput) {
      data = {
        type: 'FBZ',
        new_info: false,
        customer_group_id: customerGroup?.id,
        customer_id: selectedCustomer?.id,
        payment_status_id: paymentStatus?.id,
        logistic_line_id: logisticLineManual.id,
        contact_name: contactPerson,
        contact_phone: contactPhone,
        delivery_date: deliveryDate,
        payment_date: paymentDate,
        remark: orderRemark,
        additional_fee: additionalFee,
        po_number: poNumber,
        reference_number: referenceNumber,
        products: simplifiedProducts,
        earliest_delivery_time: formatTimeRange(
          earliestDeliveryTimeFrom,
          earliestDeliveryTimeTo
        ),
        latest_delivery_time: formatTimeRange(
          latestDeliveryTimeFrom,
          latestDeliveryTimeTo
        ),
      };
    } else {
      data = {
        type: 'FBZ',
        new_info: true,
        customer_group_id: customerGroup?.id,
        payment_status_id: paymentStatus?.id,
        delivery_date: deliveryDate,
        payment_date: paymentDate,
        earliest_delivery_time: formatTimeRange(
          earliestDeliveryTimeFromManual,
          earliestDeliveryTimeToManual
        ),
        latest_delivery_time: formatTimeRange(
          latestDeliveryTimeFromManual,
          latestDeliveryTimeToManual
        ),
        remark: orderRemark,
        additional_fee: additionalFee,
        po_number: poNumber,
        reference_number: referenceNumber,
        logistic_line_id: logisticLineManual.id,
        contact_name: contactPersonManual,
        contact_phone: contactPhoneManual,
        district_id: districtManual.id,
        area_id: areaManual.id,
        payment_method_id: paymentMethodManual.id,
        delivery_address: deliveryAddressManual,
        save_as_customer: saveToCustomerData === 'yes' ? true : false,
        products: simplifiedProducts,
      };
    }

    const response = await addOrders(data);
    if (response.success) {
      onSuccess();
      setLoader(false); // Start loading
      setAddModal(false);
      showSuccessToast(response.message);

      return response;
    } else {
      // setTmrCheck(false)
      setLoader(false);
    }
    // Add your save logic here
  };
  const handleModalSuccess = () => {
    setConfirmationModal(false);
    setTmrCheck(true);
    saveSubmit();
  };
  const validateTimeRange = (from, to, fieldName) => {
    if (from && to) {
      const fromTime = new Date(`1970-01-01T${from}`);
      const toTime = new Date(`1970-01-01T${to}`);

      if (fromTime >= toTime) {
        toast.error(`${fieldName} "To" time must be later than "From" time`);
        return false;
      }
    }
    return true;
  };
  return (
    <div className="modal fade show d-block add-new-fbz" id="add-order-modal">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h1 className="modal-title fs-5">{t('ADDNEWFBZORDER')}</h1>
            <button
              type="button"
              className="btn-close"
              onClick={() => setAddModal(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="input-main">
              <div className="row">
                {/* Delivery Date */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="date"
                      name="deliveryDate"
                      value={deliveryDate}
                      onChange={(e) => setDeliveryDate(e.target.value)}
                    />
                    <label className="delivery-label">
                      {t('DELIVERYDATE')}
                    </label>
                  </div>
                </div>
                {/* Customer Group Code */}
                {/* <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={customerGroup.id}
                      onChange={handleCustomerGroupChange}
                    >
                      <option value="" disabled={!!customerGroup.id}>
                        {t('SELECTCUSTOMERGROUPCODE')}
                      </option>
                      {groupNames.map((group) => (
                        <option key={group.id} value={group.id}>
                          {group.code}
                        </option>
                      ))}
                    </select>
                    <label>{t('CUSTOMERGROUPCODE')}</label>
                  </div>
                </div> */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <AsyncPaginate
                      value={
                        customerGroup?.id
                          ? {
                              value: customerGroup.id,
                              label: customerGroup.code,
                            }
                          : null
                      }
                      loadOptions={customerGroupLoadOptions('code')}
                      onChange={(selectedOption) => {
                        handleCustomerGroupChange(selectedOption);
                      }}
                      placeholder={t('SELECTCUSTOMERGROUPCODE')}
                      isClearable
                      additional={{ page: 1 }}
                      className="w-100"
                      styles={{
                        control: (base) => {
                          const width = window.innerWidth;
                          let height = '46px';

                          if (width <= 1760) height = '45px';
                          if (width <= 1660) height = '39px';
                          if (width <= 1024) height = '39px';

                          return {
                            ...base,
                            minHeight: height,
                            height: height,
                          };
                        },
                        valueContainer: (base) => {
                          const width = window.innerWidth;
                          let height = '46px';

                          if (width <= 1760) height = '45px';
                          if (width <= 1660) height = '39px';
                          if (width <= 1024) height = '39px';

                          return {
                            ...base,
                            height: height,
                            padding: '0 8px',
                          };
                        },
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                        }),
                        indicatorsContainer: (base) => {
                          const width = window.innerWidth;
                          let height = '46px';

                          if (width <= 1760) height = '45px';
                          if (width <= 1660) height = '39px';
                          if (width <= 1024) height = '39px';

                          return {
                            ...base,
                            height: height,
                          };
                        },
                      }}
                    />
                  </div>
                </div>

                {/* Customer Group Name Select */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <AsyncPaginate
                      value={
                        customerGroup?.id
                          ? {
                              value: customerGroup.id,
                              label: customerGroup.group,
                            }
                          : null
                      }
                      loadOptions={customerGroupLoadOptions('group')}
                      onChange={(selectedOption) => {
                        handleCustomerGroupChange(selectedOption);
                      }}
                      placeholder={t('SELECTCUSTOMERGROUPNAME')}
                      isClearable
                      additional={{ page: 1 }}
                      className="w-100"
                      styles={{
                        control: (base) => {
                          const width = window.innerWidth;
                          let height = '46px';

                          if (width <= 1760) height = '45px';
                          if (width <= 1660) height = '39px';
                          if (width <= 1024) height = '39px';

                          return {
                            ...base,
                            minHeight: height,
                            height: height,
                          };
                        },
                        valueContainer: (base) => {
                          const width = window.innerWidth;
                          let height = '46px';

                          if (width <= 1760) height = '45px';
                          if (width <= 1660) height = '39px';
                          if (width <= 1024) height = '39px';

                          return {
                            ...base,
                            height: height,
                            padding: '0 8px',
                          };
                        },
                        input: (base) => ({
                          ...base,
                          margin: 0,
                          padding: 0,
                        }),
                        indicatorsContainer: (base) => {
                          const width = window.innerWidth;
                          let height = '46px';

                          if (width <= 1760) height = '45px';
                          if (width <= 1660) height = '39px';
                          if (width <= 1024) height = '39px';

                          return {
                            ...base,
                            height: height,
                          };
                        },
                      }}
                    />
                  </div>
                </div>
                {/* Customer Group Name */}
                {/* <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={customerGroup.id}
                      onChange={handleCustomerGroupChange}
                    >
                      <option value="" disabled={!!customerGroup.id}>
                        {t('SELECTCUSTOMERGROUPNAME')}
                      </option>
                      {groupNames.map((group) => (
                        <option key={group.id} value={group.id}>
                          {group.group}
                        </option>
                      ))}
                    </select>
                    <label>{t('CUSTOMERGROUPNAME')}</label>
                  </div>
                </div> */}
                {/* Reference Number */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="text"
                      className="w-100"
                      value={referenceNumber}
                      onChange={(e) => setReferenceNumber(e.target.value)}
                    />
                    <label>{t('REFERENCENUMBER')}</label>
                  </div>
                </div>
                {/* PO Number */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="text"
                      value={poNumber}
                      onChange={(e) => setPoNumber(e.target.value)}
                    />
                    <label>{t('PONUMBER')}</label>
                  </div>
                </div>

                {/* Input fields are here enabled starts */}
                {enableInput && (
                  <>
                    {/* Delivery Address */}
                    <div className="col-sm-4">
                      <div className="d-flex justify-content-between add-new-btns">
                        <div className="custom-floating-group w-75">
                          <input
                            type="text"
                            value={deliveryAddressManual}
                            onChange={(e) =>
                              setManualDeliveryAddress(e.target.value)
                            }
                          />
                          <label>{t('DELIVERYADDRESS')}</label>
                        </div>
                        <button
                          className="btn btn-success btn-new"
                          onClick={() => {
                            toggleInput(false);
                          }}
                        >
                          {t('BACK')}
                        </button>
                      </div>
                    </div>

                    {/* Area (Dropdown) */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <select
                          value={areaManual.name}
                          onChange={handleAreaChange}
                        >
                          <option value="">{t('SELECTAREA')}</option>
                          {areaOptions.map((area) => (
                            <option key={area.id} value={area.name}>
                              {area.name}
                            </option>
                          ))}
                        </select>
                        <label>{t('AREA')}</label>
                      </div>
                    </div>

                    {/* District (Dropdown) */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <select
                          value={districtManual.name}
                          onChange={handleDistrictChange}
                        >
                          <option value="">{t('SELECTDISTRICT')}</option>
                          {districtOptions.map((district) => (
                            <option key={district.id} value={district.name}>
                              {district.name}
                            </option>
                          ))}
                        </select>
                        <label>{t('DISTRICT')}</label>
                      </div>
                    </div>

                    {/* Contact Person */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <input
                          type="text"
                          value={contactPersonManual}
                          onChange={(e) =>
                            setManualContactPerson(e.target.value)
                          }
                        />
                        <label>{t('CONTACTPERSON')}</label>
                      </div>
                    </div>

                    {/* Contact Phone */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <input
                          type="text"
                          value={contactPhoneManual}
                          onChange={(e) =>
                            setManualContactPhone(e.target.value)
                          }
                        />
                        <label>{t('CONTACTPHONE')}</label>
                      </div>
                    </div>

                    {/* Payment Method */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <select
                          value={paymentMethodManual.name}
                          onChange={handlePaymentMethodChange}
                        >
                          <option value="">{t('SELECTPAYMENTMETHOD')}</option>
                          {paymentMethodsOptions.map((method) => (
                            <option key={method.id} value={method.name}>
                              {method.name}
                            </option>
                          ))}
                        </select>
                        <label>{t('PAYMENTMETHOD')}</label>
                      </div>
                    </div>
                  </>
                )}
                {/* Input fields are here enabled ends */}

                {!enableInput && (
                  <>
                    {/** Delivery Address */}
                    <div className="col-sm-4">
                      <div className="d-flex justify-content-between add-new-btns">
                        <div className="custom-floating-group w-75">
                          <select
                            // value={deliveryAddress}
                            value={selectedCustomer?.id || ''}
                            onChange={(e) =>
                              handleDropdownChange(
                                'deliveryAddress',
                                e.target.value
                              )
                            }
                          >
                            <option value="" disabled={!!selectedCustomer.id}>
                              {t('SELECTDELIVERYADDRESS')}
                            </option>
                            {customers.map((customer, i) => (
                              // <option key={i} value={customer.delivery_address}>
                              <option key={i} value={customer.id}>
                                {customer.delivery_address}
                              </option>
                            ))}
                          </select>
                          <label>{t('DELIVERYADDRESS')}</label>
                        </div>
                        <button
                          className="btn btn-success btn-new"
                          onClick={() => toggleInput(true)}
                        >
                          {t('ADDNEW')}
                        </button>
                      </div>
                    </div>

                    {/** Area */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <select
                          // value={area}
                          value={selectedCustomer.id || ''}
                          onChange={(e) =>
                            handleDropdownChange('area', e.target.value)
                          }
                        >
                          <option value="" disabled={!!selectedCustomer.id}>
                            {t('SELECTAREA')}
                          </option>
                          {customers.map((customer, i) => (
                            // <option key={i} value={customer.area?.name}>
                            <option key={i} value={customer.id}>
                              {customer.area?.name}
                            </option>
                          ))}
                        </select>
                        <label>{t('AREA')}</label>
                      </div>
                    </div>

                    {/** District */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <select
                          // value={district}
                          value={selectedCustomer.id || ''}
                          onChange={(e) =>
                            handleDropdownChange('district', e.target.value)
                          }
                        >
                          <option value="" disabled={!!selectedCustomer.id}>
                            {t('SELECTDISTRICT')}
                          </option>
                          {customers.map((customer, i) => (
                            // <option key={i} value={customer.district?.name}>
                            <option key={i} value={customer.id}>
                              {customer.district?.name}
                            </option>
                          ))}
                        </select>
                        <label>{t('DISTRICT')}</label>
                      </div>
                    </div>

                    {/** Contact Person */}
                    {/* <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <select
                          // value={contactPerson}
                          value={selectedCustomer.id || ''}
                          onChange={(e) =>
                            handleDropdownChange(
                              'contactPerson',
                              e.target.value
                            )
                          }
                        >
                          <option value="" disabled={!!selectedCustomer.id}>
                            {t('SELECTCONTACTPERSON')}
                          </option>
                          {customers.map((customer, i) => (
                            // <option key={i} value={customer.contact_name}>
                            <option key={i} value={customer.id}>
                              {customer.contact_name}
                            </option>
                          ))}
                        </select>
                        <label>{t('CONTACTPERSON')}</label>
                      </div>
                    </div> */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <input
                          type="text"
                          name="contact_person"
                          value={contactPerson}
                          onChange={(e) => setContactPerson(e.target.value)}
                        />
                        <label>{t('CONTACTPERSON')}</label>
                      </div>
                    </div>
                    {/** Contact Phone */}
                    {/* <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <select
                          // value={contactPhone}
                          value={selectedCustomer.id || ''}
                          onChange={(e) =>
                            handleDropdownChange('contactPhone', e.target.value)
                          }
                        >
                          <option value="" disabled={!!selectedCustomer.id}>
                            {t('SELECTCONTACTPHONE')}
                          </option>
                          {customers.map((customer, i) => (
                            // <option key={i} value={customer.contact_phone}>
                            <option key={i} value={customer.id}>
                              {customer.contact_phone}
                            </option>
                          ))}
                        </select>
                        <label>{t('CONTACTPHONE')}</label>
                      </div>
                    </div> */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <input
                          type="text"
                          name="contact_phone"
                          value={contactPhone}
                          onChange={(e) => setContactPhone(e.target.value)}
                        />
                        <label>{t('CONTACTPHONE')}</label>
                      </div>
                    </div>

                    {/* Payment Method */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <select
                          // value={paymentMethod}
                          value={selectedCustomer.id || ''}
                          onChange={(e) =>
                            handleDropdownChange(
                              'paymentMethod',
                              e.target.value
                            )
                          }
                        >
                          <option value="" disabled={!!selectedCustomer.id}>
                            {t('SELECTPAYMENTMETHOD')}
                          </option>
                          {customers.map((customer, i) => (
                            // <option key={i} value={customer?.payment_method?.name}>
                            <option key={i} value={customer?.id}>
                              {customer?.payment_method?.name}
                            </option>
                          ))}
                          {/* Populate options dynamically */}
                        </select>
                        <label>{t('PAYMENTMETHOD')}</label>
                      </div>
                    </div>
                  </>
                )}
                {/* Logistic Line (Dropdown) */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={logisticLineManual.name}
                      onChange={handleLogisticLineChange}
                    >
                      <option value="">{t('SELECTLOGISTICLINE')}</option>
                      {logisticLineOptions.map((line) => (
                        <option key={line.id} value={line.name}>
                          {line.name}
                        </option>
                      ))}
                    </select>
                    <label>{t('LOGISTICLINE')}</label>
                  </div>
                </div>
                {/* Payment Status */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <select
                      value={paymentStatus.name}
                      onChange={handlePaymentStatusChange}
                    >
                      <option value="">{t('SELECTPAYMENTSTATUS')}</option>
                      {paymentOptions.map((paymentOption, i) => (
                        <option key={i} value={paymentOption.name}>
                          {paymentOption.name}
                        </option>
                      ))}
                    </select>
                    <label>{t('PAYMENTSTATUS')}</label>
                  </div>
                </div>
                {/* Payment Date */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="date"
                      value={paymentDate}
                      onChange={(e) => setPaymentDate(e.target.value)}
                    />
                    <label>{t('PAYMENTDATE')}</label>
                  </div>
                </div>
                {/* Order Remark */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="text"
                      value={orderRemark}
                      onChange={(e) => setOrderRemark(e.target.value)}
                    />
                    <label>{t('ORDERREMARK')}</label>
                  </div>
                </div>
                {/* Additional Fee */}
                <div className="col-sm-4">
                  <div className="custom-floating-group">
                    <input
                      type="number"
                      value={additionalFee}
                      onChange={(e) => setAdditionalFee(e.target.value)}
                    />
                    <label>{t('ADDITIONALFEE')}</label>
                  </div>
                </div>

                {/* Input fields are here enabled starts */}

                {enableInput && (
                  <>
                    {/* Earliest Delivery Time From */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <BasicTimePicker
                          name="earliestDeliveryTimeFromManual"
                          value={earliestDeliveryTimeFromManual || null}
                          placeholder={t('EARLIESTDELIVERYTIMEFROM')}
                          onChange={(time, name) => {
                            if (!time) return;
                            const value = time.format('HH:mm');
                            setManualEarliestDeliveryTimeFrom(value);
                            validateTimeRange(
                              value,
                              earliestDeliveryTimeToManual,
                              'Earliest Delivery Time'
                            );
                          }}
                        />
                      </div>
                    </div>

                    {/* Earliest Delivery Time To */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <BasicTimePicker
                          name="earliestDeliveryTimeToManual"
                          value={earliestDeliveryTimeToManual || null}
                          placeholder={t('EARLIESTDELIVERYTIMETO')}
                          onChange={(time, name) => {
                            if (!time) return;
                            const value = time.format('HH:mm');
                            setManualEarliestDeliveryTimeTo(value);
                            validateTimeRange(
                              earliestDeliveryTimeFromManual,
                              value,
                              'Earliest Delivery Time'
                            );
                          }}
                        />
                      </div>
                    </div>

                    {/* Latest Delivery Time From */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <BasicTimePicker
                          name="latestDeliveryTimeFromManual"
                          value={latestDeliveryTimeFromManual || null}
                          placeholder={t('LATESTDELIVERYTIMEFROM')}
                          onChange={(time, name) => {
                            if (!time) return;
                            const value = time.format('HH:mm');
                            setManualLatestDeliveryTimeFrom(value);
                            validateTimeRange(
                              value,
                              latestDeliveryTimeToManual,
                              'Latest Delivery Time'
                            );
                          }}
                        />
                      </div>
                    </div>

                    {/* Latest Delivery Time To */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <BasicTimePicker
                          name="latestDeliveryTimeToManual"
                          value={latestDeliveryTimeToManual || null}
                          placeholder={t('LATESTDELIVERYTIMETO')}
                          onChange={(time, name) => {
                            if (!time) return;
                            const value = time.format('HH:mm');
                            setManualLatestDeliveryTimeTo(value);
                            validateTimeRange(
                              latestDeliveryTimeFromManual,
                              value,
                              'Latest Delivery Time'
                            );
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}
                {/* Input fields are here enabled ends */}

                {!enableInput && (
                  <>
                    {/* Earliest Delivery Time From */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <BasicTimePicker
                          name="earliestDeliveryTimeFrom"
                          value={earliestDeliveryTimeFrom || null}
                          placeholder={t('EARLIESTDELIVERYTIMEFROM')}
                          onChange={(time, name) => {
                            if (!time) return;
                            const value = time.format('HH:mm');
                            setEarliestDeliveryTimeFrom(value);
                            validateTimeRange(
                              value,
                              earliestDeliveryTimeTo,
                              'Earliest Delivery Time'
                            );
                          }}
                        />
                      </div>
                    </div>
                    {/* Earliest Delivery Time To */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <BasicTimePicker
                          name="earliestDeliveryTimeTo"
                          value={earliestDeliveryTimeTo || null}
                          placeholder={t('EARLIESTDELIVERYTIMETO')}
                          onChange={(time, name) => {
                            if (!time) return;
                            const value = time.format('HH:mm');
                            setEarliestDeliveryTimeTo(value);
                            validateTimeRange(
                              earliestDeliveryTimeFrom,
                              value,
                              'Earliest Delivery Time'
                            );
                          }}
                        />
                      </div>
                    </div>
                    {/* Latest Delivery Time From */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <BasicTimePicker
                          name="latestDeliveryTimeFrom"
                          value={latestDeliveryTimeFrom || null}
                          placeholder={t('LATESTDELIVERYTIMEFROM')}
                          onChange={(time, name) => {
                            if (!time) return;
                            const value = time.format('HH:mm');
                            setLatestDeliveryTimeFrom(value);
                            validateTimeRange(
                              value,
                              latestDeliveryTimeTo,
                              'Latest Delivery Time'
                            );
                          }}
                        />
                      </div>
                    </div>
                    {/* Latest Delivery Time To */}
                    <div className="col-sm-4">
                      <div className="custom-floating-group">
                        <BasicTimePicker
                          name="latestDeliveryTimeTo"
                          value={latestDeliveryTimeTo || null}
                          placeholder={t('LATESTDELIVERYTIMETO')}
                          onChange={(time, name) => {
                            if (!time) return;
                            const value = time.format('HH:mm');
                            setLatestDeliveryTimeTo(value);
                            validateTimeRange(
                              latestDeliveryTimeFrom,
                              value,
                              'Latest Delivery Time'
                            );
                          }}
                        />
                      </div>
                    </div>
                  </>
                )}

                {enableInput && (
                  <>
                    <div className="col-sm-4">
                      <div className="d-flex justify-content-between my-2 add-radio">
                        <label>{t('SAVETOCUSTOMERDATA')}</label>
                        <div className="d-flex gap-2">
                          <label>
                            <input
                              type="radio"
                              name="saveToCustomerData"
                              value="yes"
                              checked={saveToCustomerData === 'yes'}
                              onChange={handleRadioChange}
                            />
                            {t('YES')}
                          </label>
                          <label>
                            <input
                              type="radio"
                              name="saveToCustomerData"
                              value="no"
                              checked={saveToCustomerData === 'no'}
                              onChange={handleRadioChange}
                            />
                            {t('NO')}
                          </label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>
            {/* Products Section */}
            <section className="products-section">
              <h5>{t('PRODUCTSINFO')}</h5>
              <button className="btn btn-success" onClick={addProduct}>
                {t('ADDPRODUCT')}
              </button>
              <div
                className={`table-outer ${products.length > 0 ? 'scroll' : ''}`}
              >
                <table className="table">
                  <thead>
                    <tr className="t-heading">
                      <th className="id">
                        <h5>#</h5>
                      </th>
                      <th className="code">
                        <h5>{t('PRODUCTCODE')}</h5>
                      </th>
                      <th className="name">
                        <h5>{t('PRODUCTNAME')}</h5>
                      </th>
                      <th className="origin">
                        <h5>{t('ORIGIN')}</h5>
                      </th>
                      <th className="specification">
                        <h5>{t('SPECIFICATION')}</h5>
                      </th>
                      <th className="quantity">
                        <h5>{t('QUANTITY')}</h5>
                      </th>
                      <th className="unit-price">
                        <h5>{t('UNITPRICE')}</h5>
                      </th>
                      <th className="discount">
                        <h5>{t('DISCOUNT')}</h5>
                      </th>
                      <th className="remark">
                        <h5>{t('PRODUCTREMARK')}</h5>
                      </th>
                      <th className="location">
                        <h5>{t('PROCESSLOCATION')}</h5>
                      </th>
                      <th className="action">
                        {' '}
                        <h5>{t('ACTION')}</h5>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {products.map((product, index) => (
                      <tr
                        key={index}
                        className={`${!product?.isEditing && (actionType === 'Add' || actionType === 'Edit') ? 'editing' : ''}`}
                      >
                        <td className="id">{index + 1}</td>
                        <td className="code">
                          {/* <Select
                            name="productCode"
                            value={productInfo.find(
                              (option) =>
                                option.name === product.productCode ||
                                option.code === product.productCode
                            )}
                            onChange={(selectedOption) => {
                              // Handle the change event
                              const event = {
                                target: {
                                  name: 'productCode',
                                  value:
                                    selectedOption.code || selectedOption.name,
                                  selectedOptions: [
                                    { getAttribute: () => selectedOption.id },
                                  ],
                                },
                              };
                              handleProductChange(index, event);
                            }}
                            options={productInfo.map((product) => ({
                              value: product.code || product.name,
                              label: `${product.code} - ${product.name}`,
                              id: product.id,
                              // code: product.code,
                              // name: product.name,
                            }))}
                            isDisabled={!product.isEditing}
                            placeholder={t('SELECTPRODUCTCODE')}
                            getOptionLabel={(option) =>
                              `${option.code} - ${option.name}`
                            }
                            getOptionValue={(option) => option.value}
                          /> */}
                          <AsyncPaginate
                            value={productInfo.find(
                              (option) =>
                                option.name === product.productCode ||
                                option.code === product.productCode
                            )}
                            loadOptions={productsLoadOptions}
                            onChange={(selectedOption) => {
                              // Handle the change event
                              const event = {
                                target: {
                                  name: 'productCode',
                                  value:
                                    selectedOption.code || selectedOption.name,
                                  selectedOptions: [
                                    { getAttribute: () => selectedOption.id },
                                  ],
                                },
                              };
                              handleProductChange(index, event);
                            }}
                            placeholder={t('SEARCHANDSELECTPRODUCT')}
                            // isClearable
                            isDisabled={!product.isEditing}
                            additional={{
                              page: 1,
                            }}
                          />
                        </td>
                        <td className="name">
                          <input
                            type="text"
                            name="productName"
                            value={product.productName}
                            onChange={(e) => handleProductChange(index, e)}
                            disabled
                            ref={(el) =>
                              (dynamicSizeInputRefs.current[index] = el)
                            }
                          />
                        </td>
                        <td className="origin">
                          <input
                            type="text"
                            name="origin"
                            value={product.origin}
                            onChange={(e) => handleProductChange(index, e)}
                            disabled
                          />
                        </td>
                        <td className="specification">
                          <input
                            type="text"
                            name="specification"
                            value={product.specification}
                            onChange={(e) => handleProductChange(index, e)}
                            disabled
                            ref={(el) =>
                              (specificationInputRefs.current[index] = el)
                            }
                          />
                        </td>
                        <td className="quantity">
                          <input
                            type="number"
                            name="quantity"
                            value={product.quantity}
                            onChange={(e) => handleProductChange(index, e)}
                          />
                        </td>
                        <td className="unit-price">
                          <input
                            type="number"
                            name="unitPrice"
                            value={product.unitPrice}
                            onChange={(e) => handleProductChange(index, e)}
                          />
                        </td>
                        <td className="discount">
                          <input
                            type="number"
                            name="discount"
                            value={product.discount}
                            onChange={(e) => handleProductChange(index, e)}
                            onBlur={(e) => {
                              const discount = parseFloat(e.target.value) || 0;
                              const unitPrice =
                                parseFloat(product.unitPrice) || 0;
                              const quantity =
                                parseFloat(product.quantity) || 0;
                              const productValue = unitPrice * quantity;

                              if (discount > productValue) {
                                handleProductChange(index, {
                                  target: {
                                    name: 'discount',
                                    value: productValue,
                                  },
                                });
                                toast.error(
                                  `${t('DISCOUNTCANNOTEXCEEDPRODUCTVALUE')} (${productValue})`
                                );
                              }
                            }}
                            min={0}
                          />
                          {product.discount >
                            product.unitPrice * product.quantity && (
                            <span className="error-message">
                              {t('DISCOUNTCANNOTEXCEEDPRODUCTVALUE')}
                              {product.unitPrice * product.quantity}
                            </span>
                          )}
                        </td>
                        <td className="remark">
                          <input
                            type="text"
                            name="productRemark"
                            value={product.productRemark}
                            onChange={(e) => handleProductChange(index, e)}
                            ref={(el) =>
                              (productRemarkInputRefs.current[index] = el)
                            }
                          />
                        </td>
                        <td className="location">
                          <input
                            type="text"
                            name="processLocation"
                            value={product.processLocation}
                            onChange={(e) => handleProductChange(index, e)}
                            disabled
                          />
                        </td>
                        <td className="action">
                          <div className="d-flex gap-1">
                            {actionType === 'Edit' && (
                              <button
                                className="btn btn-primary"
                                onClick={() => toggleEdit(index)}
                              >
                                <img src="images/green-edit.svg" alt="Edit" />
                              </button>
                            )}
                            <button
                              className="btn btn-danger"
                              onClick={() => removeProduct(index)}
                            >
                              <img src="images/red-delete.svg" alt="" />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </section>
            {/* Bottom buttons */}
            <div className="bottom-button">
              <button
                className="cancel"
                onClick={() => setAddModal(false)}
                disabled={loader}
              >
                {t('CANCEL')}
              </button>
              <button
                className="save"
                onClick={() => saveSubmit()}
                disabled={loader}
              >
                {loader && (
                  <div className="spinner-border" role="status">
                    <span className="sr-only"></span>
                  </div>
                )}
                {t('SAVE')}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Modal
        isOpen={confirmationModal}
        onRequestClose={() => setConfirmationModal(false)}
        shouldCloseOnOverlayClick={false}
        ariaHideApp={false}
        overlayClassName={`modal-overlay add `}
        portalClassName="add cut-off"
      >
        <ConfirmationModal
          type={category}
          setConfirmationModal={setConfirmationModal}
          selectedOrdersEdit={selectedOrdersEdit}
          actionType={'Add'}
          onSuccess={handleModalSuccess}
        />
      </Modal>
    </div>
  );
};

export default AddOrderModalUpdate;
